import { YattaLangDefinition } from './model/yatta-language-definition';

export const GERMAN: YattaLangDefinition = { id: 'de', label: 'Deutsch' };
export const ENGLISH: YattaLangDefinition = { id: 'en', label: 'English' };
